<template>
  <div class="">
    <!-- Título principal -->
    <div class="my-6">
      <h1 class="text-2xl font-bold text-gray-800 mb-2">
        Rendiciones
      </h1>
    </div>

    <!-- Layout en dos columnas sin v-row -->
    <div class="grid grid-cols-2 xl:grid-cols-2 gap-6 xl:gap-8">
      <!-- Columna izquierda - Documentación -->
      <div class="space-y-4 xl:space-y-6">
        <!-- Información del endpoint -->
        <div class="bg-white rounded-lg border border-gray-200 p-4 xl:p-6">
          <h3 class="text-lg xl:text-xl font-semibold mb-3 flex items-center">
            <span
              class="bg-green-100 text-green-800 px-2 py-1 rounded text-sm xl:text-base font-mono mr-3"
              >GET</span
            >
            <span class="text-xs xl:text-base">
              https://sb-wee.ar/v1/reporte/rendiciones?Date=03-01-2023</span
            >
          </h3>
          <p class="text-gray-600 text-sm xl:text-base mb-2">
            Retorna el detalle de transacciones que conforman una rendición para
            el día especificado. Solo se realizan rendiciones los días hábiles.
          </p>
        </div>

        <!-- Parámetros -->
        <h4 class="font-semibold mb-3 xl:mb-4 text-base xl:text-lg">
          Request
        </h4>

        <!-- Headers Table -->
        <DynamicTable
          title="Headers"
          :headers="headersRendiciones"
          :data="headersData"
          height="auto"
        />

        <!-- Body Table -->
        <DynamicTable
          title="Path parameters"
          :headers="bodyHeaders"
          :data="bodyParameters"
          height="auto"
        />

        <!-- Response -->
        <h4 class="font-semibold mb-3 xl:mb-4 text-base xl:text-lg">
          Response
        </h4>

        <DynamicTable
          title="Atributos del objeto de la respuesta."
          :headers="responseHeaders"
          :data="responseData"
          height="auto"
        />

        <DynamicTable
          title="Atributos del objeto result."
          :headers="responseHeadersDataResult"
          :data="responseResultData"
          height="150px"
        />

        <DynamicTable
          title="Atributos del objeto data."
          :headers="responseHeadersObjet"
          :data="responseObjectData"
          height="auto"
        />
      </div>

      <!-- Columna derecha - Ejemplos de código -->
      <div class="space-y-4 xl:space-y-6">
        <!-- Request Example -->

        <div class="bg-white rounded-lg border border-gray-200 p-3 xl:p-6">
          <h4 class="text-lg xl:text-xl font-semibold mb-3 flex items-center">
            Headers
          </h4>
          <span class="text-black">
            <p>
              <code class="text-black">Content-Type: application/json</code>
            </p>
            <p>
              <code class="text-black"
                >Authorization: Bearer {{ apikeyExample }}</code
              >
            </p>
          </span>
        </div>

        <!-- Response Example -->
        <CodeBlock
          title="Example Response"
          :code="responseExample"
          language="json"
          status="info"
          :is-large="true"
        />
      </div>
    </div>
  </div>
</template>
<script>
import DynamicTable from "../shared/DynamicTable.vue";
import CodeBlock from "../shared/CodeBlock.vue";

export default {
  name: "CrearSolicitudPago",
  components: {
    DynamicTable,
    CodeBlock,
  },
  data() {
    return {
      // Configuración de headers para la tabla de Headers
      headersRendiciones: [
        { key: "atributo", label: "atributo", isCode: true },
        { key: "tipo", label: "TIPO" },
        { key: "requerido", label: "REQUERIDO" },
        { key: "pattern", label: "PATTERN" },
        { key: "descripcion", label: "DESCRIPCIÓN" },
      ],

      // Datos de headers
      headersData: [
        {
          atributo: "Content-Type",
          tipo: "String",
          requerido: "Sí",
          pattern: "application/json",
          descripcion:
            "El tipo MIME del contenido del cuerpo enviado. Por defecto JSON es Unicode UTF-8. No se debe configurar otro charset.",
        },
        {
          atributo: "Authorization",
          tipo: "String",
          requerido: "Sí",
          pattern: "Bearer",
          descripcion: "ba7943e1-a60c-43e7-8812-xxxxxxxxxxxx",
        },
      ],

      // Configuración de headers para la tabla de Body
      bodyHeaders: [
        { key: "atributo", label: "ATRIBUTO", isCode: true },
        { key: "tipo", label: "TIPO" },
        { key: "requerido", label: "REQUERIDO" },
        { key: "descripcion", label: "DESCRIPCIÓN" },
      ],

      // Datos de parámetros del body
      bodyParameters: [
        {
          atributo: "Date",
          tipo: "String",
          requerido: "Sí",
          descripcion:
            "Fecha de la rendicion. Solo se muestra información de las rendiciones aprobadas. Formato DD-MM-YYYY",
        },
      ],

      // Response
      responseHeaders: [
        { key: "atributo", label: "atributo", isCode: true },
        { key: "tipo", label: "TIPO" },
        { key: "descripcion", label: "DESCRIPCIÓN" },
      ],

      responseData: [
        {
          atributo: "message",
          tipo: "String",
          descripcion: "Mensaje de la respuesta.",
        },
        {
          atributo: "result",
          tipo: "Object",
          descripcion: "Objeto con la información de la respuesta.",
        },
        {
          atributo: "status",
          tipo: "Boolean",
          descripcion: "Estado de la respuesta.",
        },
      ],

      responseHeadersDataResult: [
        { key: "atributo", label: "atributo", isCode: true },
        { key: "tipo", label: "TIPO" },
        { key: "descripcion", label: "DESCRIPCIÓN" },
      ],

      responseResultData: [
        {
          atributo: "account_id",
          tipo: "String",
          descripcion: "ID de la cuenta propietaria del Reporte.",
        },
        {
          atributo: "report_date",
          tipo: "String",
          descripcion: "Fecha de rendición.",
        },
        {
          atributo: "total_credits",
          tipo: "Integer",
          descripcion: "Cantidad total de operaciones acreditadas.",
        },
        {
          atributo: "credit_amount",
          tipo: "Float",
          descripcion:
            "Importe total de operaciones acreditadas. Formato: 00000000.00 (hasta 8 enteros y 2 decimales, utilizando punto “.” como separador decimal).",
        },
        {
          atributo: "total_debits",
          tipo: "Integer",
          descripcion: "Cantidad total de débitos.",
        },
        {
          atributo: "debit_amount",
          tipo: "Float",
          descripcion:
            "Importe Total de operaciones debitadas. Formato: 00000000.00 (hasta 8 enteros y 2 decimales, utilizando punto “.” como separador decimal).",
        },
        {
          atributo: "settlement_amount",
          tipo: "Float",
          descripcion:
            "Importe total rendido. Formato: 00000000.00 (hasta 8 enteros y 2 decimales, utilizando punto “.” como separador decimal).",
        },
        {
          atributo: "data",
          tipo: "Array [Object]",
          descripcion: "Arreglo de objetos con detalle de cada rendición.",
        },
      ],

      responseHeadersObjet: [
        { key: "atributo", label: "atributo", isCode: true },
        { key: "tipo", label: "TIPO" },
        { key: "descripcion", label: "DESCRIPCIÓN" },
      ],

      responseObjectData: [
        {
          atributo: "request_id",
          tipo: "Integer",
          descripcion:
            "ID de la solicitud. Solicitud de pago o debito según corresponda.",
        },
        {
          atributo: "external_reference",
          tipo: "String",
          descripcion:
            "Este atributo es utilizado como referencia para identificar la solicitud y sincronizar con tus sistemas de backend el origen de la operación.",
        },
        {
          atributo: "credit",
          tipo: "Float",
          descripcion:
            "Importe acreditado. Formato: 00000000.00 (hasta 8 enteros y 2 decimales, utilizando punto “.” como separador decimal).",
        },
        {
          atributo: "debit",
          tipo: "Float",
          descripcion:
            "Importe debitado. Formato: 00000000.00 (hasta 8 enteros y 2 decimales, utilizando punto “.” como separador decimal).",
        },
      ],

      apikeyExample: " {{ apikey }}",

      responseExample: `{
        "message": "Solicitud rendiones generada",
        "result": {
            "account_id": "000004",
            "report_date": "2023-01-31T00:00:00Z",
            "total_credits": 3,
            "credit_amount": 27794.02,
            "total_debits": 0,
            "debit_amount": 0,
            "settlement_amount": 27794.02,
            "data": [
                {
                    "request_id": 641,
                    "external_reference": "JPKdsohhr",
                    "credit": 4814.76,
                    "debit": 0
                },
                {
                    "request_id": 712,
                    "external_reference": "ARslPzml1",
                    "credit": 11489.63,
                    "debit": 0
                },
                {
                    "request_id": 716,
                    "external_reference": "S5oXveLa4",
                    "credit": 11489.63,
                    "debit": 0
                }
            ]
        },
        "status": true
        }`,
    };
  },
};
</script>

<style scoped>
/* Responsive adjustments para el grid */
@media (max-width: 1279px) {
  .grid-cols-1.xl\:grid-cols-2 {
    grid-template-columns: 1fr;
  }
}
</style>
